import Phaser from "phaser";

const events = new Phaser.Events.EventEmitter();

export default events;
